import React from "react";
import PlaceholderPage from "./PlaceholderPage";

export const PLACEHOLDERS = {
  // Prodotti
  "prodotti/corsi": {
    eyebrow: "Prodotti · Corsi",
    title: "Corsi.",
    description:
      "Percorsi di apprendimento strutturati. Contenuti in preparazione.",
    backTo: "/prodotti",
    backLabel: "Torna a Prodotti",
    testId: "prodotti-corsi",
  },
};

export function makePlaceholder(key) {
  const cfg = PLACEHOLDERS[key];
  const Component = () => <PlaceholderPage {...cfg} />;
  Component.displayName = `Placeholder(${key})`;
  return Component;
}
